import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { black } from '../../../colors'
import alertIcon from '../../../assets/alert-circle.svg'

export const NoStudentsAlert: React.FC = () => {
  const theme = useTheme()
  return (
    <Box sx={{ flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
      <img src={alertIcon} />
      <Typography sx={{ ml: 1 }} variant='h6' fontSize={theme.spacing(4)} color={black[100]}>
        No students are currently enrolled in this course section.
      </Typography>
    </Box>
  )
}
